// extracted by css-extract-rspack-plugin
export default {"expandTriangleIcon":"SubIssuesSummaryToken-module__expandTriangleIcon__wqvZWOa","SubIssuesSummaryToken":"SubIssuesSummaryToken-module__SubIssuesSummaryToken__bLlcGFR"};